import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageRevenueResponsibilityReport extends Layout {
    checkboxAvailable: Checkbox;
    checkboxDelivered: Checkbox;
    checkboxInProgress: Checkbox;
    excludabletextboxH: ExcludableTextbox;
    excludeabletextboxCarriers: ExcludableTextbox;
    excludeabletextboxControllingParties: ExcludableTextbox;
    excludeabletextboxCustomers: ExcludableTextbox;
    excludeabletextboxDispatchers: ExcludableTextbox;
    excludeabletextboxRevenueCodes: ExcludableTextbox;
    excludeabletextboxSteamshipLines: ExcludableTextbox;
    labelOrderStatuses: Label;
    panelOrderStatuses: Panel;
    sourceBrokerageRevenueResponsibility: DataSource;
    switchReportType: Switch;
    switchSortBySecondary: Switch;
    textboxDate: Textbox;
    textboxDateType: Textbox;
    textboxGroupBy: Textbox;
    textboxHierarchyLevel: Textbox;
    textboxInclude: Textbox;
    textboxSortBy: Textbox;
}
